import { ValidatorInput } from './validation/validation-descriptor.entity';
import { PasswordCriteria } from '../common.component.module/password-criteria';
import { AppConstants } from '../app-constants.service';
import { ValidationChecks } from './validation/validation-checks.enum';
import { UserValidator } from './validation/validation.user';
import { Validator } from './validation/validator.util';
import { ValidationError } from './validation/validation.error';

export class EnterNewPasswordModel {

    private readonly checkPassword = (field: ValidatorInput) => {
        field.valid = true;

        if (field.value !== this.passwordConfirm) {
            field.valid = false;
            field.errorMsg = 'Passwort und Passwort-Wiederholung stimmen nicht &uuml;berein.';
        }

        if (!UserValidator.validatePw(field.value)) {
            field.errorMsg = AppConstants.VHV_PASSWORD_ERROR_MSG;
            field.valid = false;
        }
    };

    password = new ValidatorInput(
        'password',
        '',
        'Passwort',
        PasswordCriteria.PW_ALL_CRITERIA,
        AppConstants.VHV_PASSWORD_ERROR_MSG,
        false,
        ValidationChecks.NOT_EMPTY_CHECK,
        this.checkPassword,
    );

    passwordConfirm = '';

    collection: ValidatorInput[] = [
        this.password,
    ];

    validateField(field: ValidatorInput) {
        field.valid = Validator.doValidate(field, 1, []);
    }

    validate(): ValidationError[] {
        const result: ValidationError[] = [];

        Validator.doValidate(this.password, 1, result);

        this.password.valid = result.length === 0;

        return result.length === 0 ? null : result;
    }

    mapError(input: ValidatorInput) {
        input.valid = false;
        input.errorMsg = AppConstants.VHV_PASSWORD_NOT_ALLOWED_MSG;
    }

}
